import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

const Header = () => {
    const [active, setActive] = useState('')
    useEffect(() => {
        let currentUrl = window.location.href
        console.log(currentUrl);
        if (currentUrl.endsWith('/')) {
            setActive('About');
        }
        else if (currentUrl.endsWith('/resume')) {
            setActive('Resume');
        }
        else if (currentUrl.endsWith('/projects')) {
            setActive('Projects');
        }
        else if (currentUrl.endsWith('/blog')) {
            setActive('Blogs');
        }
        else if (currentUrl.endsWith('/contactme')) {
            setActive('Contact');
        }
    }, [active])

    const navbar_variant = {
        hidden: {
            y: "-30vh",
            opacity: 0
        },
        visible: {
            y: 0,
            opacity: 1
        }
    }
    return (
        <header className="header"> 

        <a href="#" className="menu-btn"><span></span></a>


            <div className="top-menu">
                <ul>
                    <li className={active == 'About' ? "active" : "" } >
                        <Link to="/">
                            <span className="icon ion-person" onClick={() => setActive('About')}></span>
                            <span className="link">About</span>
                        </Link>
                    </li>
                    <li className={active == 'Resume' ? "active" : ""} >
                        <Link to="/resume">
                            <span className="icon ion-android-list" onClick={() => setActive('Resume')}></span>
                            <span className="link">Resume</span>
                        </Link>
                    </li>
                    <li className={active == 'Projects' ? "active" : ""} >
                        <Link to="/projects">
                            <span className="icon ion-paintbrush" onClick={() => setActive('Projects')}></span>
                            <span className="link">Projects</span>
                        </Link>
                    </li>
                    <li className={active == 'Blogs' ? "active" : ""} >
                        <Link to="/blog">
                            <span className="icon ion-chatbox-working" onClick={() => setActive('Blogs')}></span>
                            <span className="link">Blog</span>
                        </Link>
                    </li>
                    <li className={active == 'Contact' ? "active" : ""} >
                        <Link to="/contactme">
                            <span className="icon ion-at" onClick={() => setActive('Contact')}></span>
                            <span className="link">Contact</span>
                        </Link>
                    </li>
                </ul>
            </div>

        </header>
    );
}

export default Header;